import { FeedbackPromptResponseDetails } from "./EmployeeFeedbackModel";
//NewJoinerDOJA45DFREM and NewJoinerDOJA45DAFREM  Prompt -> On submission records get pushed to Strand.
export class NewJoinerDOJA45DFREMModel {
    EnterpriseId!: string;
    CardUniqueId!: string;
    CategoryType!: string;
    ChannelType!: string;
    FeedbackPromptResponseDetails !: FeedbackPromptResponseDetails[];
    IsPostAnonymous !: boolean;
}